import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Text } from "mondrian-react";

export default function TextSizeModal({
  triggerClassName,
  wrapperClassName = "",
  tabIndex = "7",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const modalHostRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeButton = modalHostRef.current
      ? modalHostRef.current.querySelector(".mdn-Button")
      : null;
    if (closeButton) closeButton.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
        const trigger = triggerRef.current && triggerRef.current.querySelector("button");
        if (trigger) trigger.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  const closeModal = () => {
    setIsOpen(false);
    const trigger = triggerRef.current && triggerRef.current.querySelector("button");
    if (trigger) trigger.focus();
  };

  return (
    <>
      <div
        className={wrapperClassName}
        data-mdn-modal-id="modal-tamanho"
        ref={triggerRef}
      >
        <Button
          aria-controls="modal-tamanho"
          aria-expanded={isOpen}
          aria-haspopup="dialog"
          aria-label="Instruções para alterar o tamanho do texto"
          className={triggerClassName}
          onClick={() => setIsOpen(true)}
          tabIndex={tabIndex}
          type="button"
        >
          <i className="mdn-Icon-diminuir-tamanho mdn-Icon--sm"></i>
          <i className="mdn-Icon-aumentar-tamanho mdn-Icon--sm"></i>
        </Button>
      </div>

      <div className="cred-TextSizeModalHost" ref={modalHostRef}>
        <Modal
          accessibility
          aria-label="Como alterar o tamanho do texto"
          data={{
            content: (
              <Text body className="cred-TextSizeModalText" tag="div">
              <div>
                Para aumentar ou reduzir a fonte, utilize os atalhos nativos do
                seu navegador:
                <br />
                <ul>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>
                    No windows&nbsp;<strong>CTRL</strong> +&nbsp;(para aumentar)
                    e&nbsp;<strong>CTRL</strong> -&nbsp;(para diminuir)
                  </li>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>
                    No macOS (safari)&nbsp;<strong>CMD</strong> +&nbsp;(para
                    aumentar) e&nbsp;<strong>CMD</strong> -&nbsp;(para diminuir)
                  </li>
                </ul>
              </div>
              </Text>
            ),
            footer: {
              action: (
                <Button block primary onClick={closeModal} type="button">
                  Ok
                </Button>
              ),
            },
            isOpen,
            onCloseClick: closeModal,
            onEscPress: closeModal,
          }}
          id="modal-tamanho"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeModal();
          }}
          role="dialog"
          sm
        />
      </div>
    </>
  );
}
